import { cn } from '#app/utils/misc.tsx'

interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
	text?: string
}

export function Divider({ text, className, ...props }: DividerProps) {
	if (text) {
		return (
			<div
				{...props}
				className={cn('relative flex items-center py-2', className)} // Apply incoming className to the main container
			>
				<div className="flex-grow border-t border-border" />
				<span className="mx-4 flex-shrink text-sm text-neutral-400">{text}</span>
				<div className="flex-grow border-t border-border" />
			</div>
		)
	}

	return <div {...props} className={cn('h-px w-full bg-border', className)} />
}
